/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($name: String, $priority: Int) {
    CategoryNameCreate(name: $name, priority: $priority) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
